<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-06-05 14:43:26
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-09-28 16:45:09
--> 
<template>
  <div class="resumePage">
    <job-header-simple header_title="接单意向"></job-header-simple>

    <van-field
      v-model="resume.areaFullName"
      label="所在地区"
      is-link
      placeholder="请选择地区"
      readonly
      @click="citySelectionShow = true"
    />
    <van-field
      v-model="resume.addr"
      rows="1"
      autosize
      label="详细地址"
      type="textarea"
      placeholder="请输入详细地址"
    />
    <div class="blockSection">
      <label class="label_line">技能证书</label>
      <van-field>
        <template #input>
          <van-uploader
            v-model="fileList"
            accept="image/*, .pdf"
            :show-upload="isShowUpload"
            @click-preview="handlePreview"
            :before-delete="deleteImg"
            :after-read="afterRead"
          />
        </template>
      </van-field>
    </div>
    <div class="blockSection">
      <label class="label_line">接单意向</label>
      <van-field
        v-model="resume.jobMemo"
        rows="4"
        autosize
        type="textarea"
        maxlength="1000"
        placeholder="请输入接单意向"
        show-word-limit
        class="textarea"
      />
    </div>
    <div class="btnSection">
      <van-button
        type="info"
        size="large"
        class="btn"
        @click="onClickButtonSubmit"
        :loading="loading"
        loading-text="提交中..."
        >提 交</van-button
      >
    </div>

    <van-popup v-model="citySelectionShow" position="bottom">
      <van-picker
        show-toolbar
        title="选择城市"
        :columns="addressList"
        @confirm="handleCityConfirm"
        @cancel="citySelectionShow = false"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  Button,
  Field,
  Toast,
  Icon,
  Uploader,
  Notify,
  Popup,
  Picker,
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import { uploadFile } from "@/api/admin/file";
import api from "@/api/list";
import { updateResume } from "@/api/employee/request";
import { mapGetters } from "vuex";
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Uploader.name]: Uploader,
    jobHeaderSimple,
    [Notify.name]: Notify,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  data() {
    return {
      citySelectionShow: false,
      loading: false,
      addressList: [],
      fileList: [],
      resume: {
        id: undefined,
        addr: undefined,
        areaFullName: undefined,
        areaId: undefined,
        jobMemo: undefined,
        skillCertificateFiles: undefined,
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isShowUpload: function () {
      return this.resume.skillCertificateFiles.length < 5;
    },
  },
  watch: {
    userInfo: {
      handler: function (val, oldVal) {
        this.resume = {
          id: val.id,
          addr: val.addr,
          areaFullName: val.areaFullName,
          areaId: val.areaId,
          jobMemo: val.jobMemo,
          skillCertificateFiles: val.skillCertificateFiles,
        };
        this.fileList = val.skillCertificateFiles;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.initAddress();
  },
  methods: {
    initAddress() {
      api.list().then((res) => {
        this.addressList = res.data.data;
      });
    },
    onClickButtonSubmit() {
      let skillCertificateFiles = "";
      let temp = Object.assign({}, this.resume);
      temp.skillCertificateFiles.forEach((item) => {
        skillCertificateFiles += item.url.replace(
          process.env.VUE_APP_FILE_PATH,
          ","
        );
      });
      temp.skillCertificateFiles = skillCertificateFiles.substring(1);
      updateResume(temp)
        .then((res) => {
          if (res.data.status == "200") {
            this.$toast("操作成功");
            this.$store.dispatch("getUserInfo");
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((error) => {
          this.$toast(error.response.data.message);
          this.loading = false;
        });
    },
    deleteImg(file, detail) {
      this.resume.skillCertificateFiles.splice(detail.index, 1);
      return true;
    },
    handleCityConfirm(text, index) {
      this.resume.areaFullName = text.join("/");
      this.resume.areaId = this.addressList[index[0]].children[
        index[1]
      ].children[index[2]].id;
      this.citySelectionShow = false;
    },
    afterRead(fileObj) {
      uploadFile("task-order", fileObj.file).then((res) => {
        if (res.data.status == "200") {
          this.resume.skillCertificateFiles.push({
            url: process.env.VUE_APP_FILE_PATH + res.data.data,
          });
        } else {
          this.$toast(res.data.message);
        }
      });
    },
    handlePreview(file) {
      if (file.url.toUpperCase().endsWith(".PDF")) {
        this.$router.push({
          path: "/checkContract",
          query: {
            fileURL: file.url,
            header_title: "查看简历",
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.btnSection {
  margin: 20px;
}

.resumePage {
  /deep/.van-field__label {
    width: 1.8rem;
  }
}

.blockSection {
  background: #fff;
  padding: 0.26667rem 0.42667rem;
  margin: 3px 0;
  .label_line {
    display: block;
    color: #323233;
    font-size: 0.37333rem;
    line-height: 0.64rem;
    margin-bottom: 6px;
  }

  .textarea {
    border-radius: 5px;
    padding: 0;
  }

  /deep/ .van-cell {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>



